import React from "react";
import { Box, TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";

function SearchBar({ filterClick, width, height, searchQuery, setSearchQuery }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: "600px",
          boxShadow: "0px 4px 25px 4px rgba(0, 0, 0, 0.1)",
          borderRadius: "36px",
          backgroundColor: "#fff",
          padding: "5px 10px",
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search experience by name"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#121212" }} />
              </InputAdornment>
            ),
            sx: {
              borderRadius: "30px",
              width: width,
              height: height,
              "& fieldset": {
                border: "none",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#121212", 
                opacity: 1, 
              },
            },
          }}
        />
      </Box>
      <IconButton
        onClick={filterClick}
        sx={{
          backgroundColor: "#FF7900",
          color: "#fff",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          "&:hover": {
            backgroundColor: "#e86a00",
          },
        }}
      >
        <FilterListIcon/>
      </IconButton>
    </Box>
  );
}

export default SearchBar;
